import { Injectable, signal, WritableSignal } from '@angular/core';
import { FilterSectionTypes } from '../../enums/inventory-management.enum';

@Injectable({ providedIn: 'root' })
export class SearchFilterSectionService {

  private searchFilterSectionSignal$: WritableSignal<FilterSectionTypes> = signal(FilterSectionTypes.OFFERS);

  constructor() { }

  setOpenFilterSection(filterSectionType: FilterSectionTypes) {
    // if trying to open a filter that's already open, close it
    this.searchFilterSectionSignal$.update((currentSignal) => (
      filterSectionType !== currentSignal ? filterSectionType : undefined
    ));
  }

  getOpenFilterSection() {
    return this.searchFilterSectionSignal$();
  }

  resetFilterSection() {
    this.searchFilterSectionSignal$.set(undefined);
  }

}
